export const toTitleCase = (s: string) => s[0].toUpperCase() + s.substr(1).toLowerCase();
